import { ARTICLES, type Article } from './articles'

/** The iOS address (`SupportLinks.supportEmail`), so both clients feed one inbox. Intake A4. */
export const SUPPORT_EMAIL = 'support@tracke5.app'
export const SHARE_URL = 'https://tracke5.com'

/** Privacy and Terms are published on the marketing site (intake B1). */
export const LEGAL_DOCS = {
  privacy: { title: 'Privacy policy', href: 'https://tracke5.com/privacy.html' },
  terms: { title: 'Terms of service', href: 'https://tracke5.com/terms.html' },
} as const

/** Trimmed, case-insensitive; every whitespace-separated term must appear somewhere in the article. */
export function searchArticles(query: string, articles: readonly Article[] = ARTICLES): readonly Article[] {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return articles
  return articles.filter((a) => {
    const haystack = [a.title, a.summary, ...a.keywords, ...a.body].join('\n').toLowerCase()
    return terms.every((t) => haystack.includes(t))
  })
}

function mailto(subject: string, body?: string): string {
  const q = [`subject=${encodeURIComponent(subject)}`]
  if (body !== undefined) q.push(`body=${encodeURIComponent(body)}`)
  return `mailto:${SUPPORT_EMAIL}?${q.join('&')}`
}

/**
 * Environment, browser and page only (intake A5). The signature takes no user,
 * account or amount, so nothing of the sort can reach the body.
 */
export function contactHref(ctx: { mode: string; userAgent: string; path: string }): string {
  const body = ['', '', '---', `Environment: ${ctx.mode}`, `Browser: ${ctx.userAgent}`, `Page: ${ctx.path}`].join('\n')
  return mailto('TrackE5 support request', body)
}

/** Subject only, no context body (iOS: includesDeviceInfo false). */
export function suggestHref(): string {
  return mailto('TrackE5 feature suggestion')
}
